import React from 'react';

function Spacer(params) {
    return <div className={"spacer"}></div>

}

export default Spacer;